<template>
  <van-popup
    :value="visible"
    :close-on-click-overlay="false"
    class="component-phone-verify"
    @click-close-icon="$emit('update:visible', false)"
  >
    <div class="van-dialog__header">手机号验证</div>
    <ErrorWrap :error-message="inputError.phone" :error="!!inputError.phone">
      <van-field
        id="phone"
        v-model="phone"
        :clearable="true"
        clear-trigger="always"
        type="tel"
        label="车主手机号"
        placeholder="请输入"
        input-align="right"
        @blur="validateField('phone')"
      />
    </ErrorWrap>
    <van-field
      ref="smsInputRef"
      id="verificationCode"
      v-model="verificationCode"
      :clearable="true"
      clear-trigger="always"
      label="验证码"
      type="digit"
      maxlength="6"
      placeholder="请输入"
      input-align="right"
    >
      <template #button>
        <div :class="isSend ? 'disabled' : ''" class="page-rnr-main-btn" @click="handleSendSms">{{ isSend ? `${countTime}s后重发` : '获取验证码' }}</div>
      </template>
    </van-field>
    <van-button
      :disabled="!phone || !verificationCode"
      :loading="loading"
      type="primary"
      class="page-rnr-main-btn-confirm"
      block
      round
      color="linear-gradient(120deg, #000 0%, #000 97%)"
      @click="handleConfirm"
    >确定</van-button>
    <div class="icon-close" @click="$emit('update:visible', false)" />
  </van-popup>
</template>
<script>
import ErrorWrap from './ErrorWrap'
import { sendSms } from '@/api/rnr'
import { markupSendSms } from '@/api/markup'
import { Toast } from 'vant'
import { validate } from '../utils/validate'

export default {
  name: 'PhoneVerify',
  components: { ErrorWrap },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSend: false,
      countTime: 59,
      phone: this.$store.getters.loginUser.phone || '',
      verificationCode: '',
      inputError: {
        phone: '',
        verificationCode: ''
      }
    }
  },
  methods: {
    /**
     * 校验手机号输入
     * @param fieldKey
     */
    validateField(fieldKey) {
      // 先清空错误信息
      this.$set(this.inputError, fieldKey, '')
      // 校验错误的key和消息
      const [failKey, failMessage] = validate({ [fieldKey]: this[fieldKey] }, [fieldKey])
      // 如果当前有错误信息
      if (failKey) {
        this.inputError[failKey] = failMessage
        return false
      }
      return true
    },

    /**
     * 发送短信验证码
     */
    async handleSendSms() {
      const validResult = this.validateField('phone')
      // 如果电话号码未输入
      if (!validResult) {
        return
      }
      // 如果已经发送过短信
      if (this.isSend) {
        return
      }
      // 发送短信
      await (this.customer ? markupSendSms : sendSms)({ phone: this.phone, bizType: 'rnr' })
      // 提示
      Toast('短信已经发送，请注意查收')
      // 标记当前已经发送过了
      this.isSend = true
      // 将输入框获取焦点
      this.$refs.smsInputRef.focus()
      // 开始倒计时
      this.countDown()
    },

    /**
     * 开始倒计时
     */
    countDown() {
      // 如果倒计时结束
      if (this.countTime === 1) {
        this.isSend = false
        this.countTime = 60
        return
      }
      // 开始将时间-1
      this.countTime--
      // 1s后执行倒计时的内容
      setTimeout(() => {
        this.countDown()
      }, 1000)
    },

    /**
     * 如果手机号和验证码输入正确
     */
    handleConfirm() {
      // 获取当前输入的手机号和验证码
      const { phone, verificationCode } = this
      // 如果校验手机号失败
      if (!this.validateField('phone')) {
        return
      }
      // 触发绑定到submit的事件
      this.$emit('submit', { phone, verificationCode })
    }
  }
}
</script>

<style lang="scss">
.component-phone-verify {
  &.van-popup {
    box-sizing: border-box;
    border-radius: 16px;
    width: 685px;
    overflow-y: visible;
    padding: 0 40px 50px;
    .van-dialog__header {
      align-items: center;
      color: #242424;
      display: flex;
      font-size: 36px;
      font-weight: 500;
      padding: 60px 0 12px;
      &:after, &:before {
        background-color: rgba(220, 223, 230, 1);
        content: "";
        display: block;
        width: 194px;
        height: 1px;
      }
      &:before {
        margin-right: 16px;
      }
      &:after {
        margin-left: 16px;
      }
    }
    .van-field__button {
      padding-left: 30px;
      .page-rnr-main-btn {
        color: #0761F3;
        font-size: 32px;
        font-weight: 400;
      }
    }
    .page-rnr-main-btn-confirm {
      margin-top: 44px;
    }
    .icon-close {
      background-image: url(../assets/rnr/ico_close_dialog.png);
      background-size: 100% 100%;
      bottom: -86px;
      left: calc(50% - 28px);
      width: 56px;
      height: 56px;
      position: absolute;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PhoneVerify.vue